<template>
    <div style="width: 100%">
        <nav-breadcrumb :menu="[{label :'发起他项出库'}]"/>
        <el-row>
            <el-col>
                <panel label="出库信息">
                    <el-form :model="dataForm" :rules="dataFormRules" ref="dataForm" label-width="150px">
                        <el-row :gutter="10" class="bg-purple xamhtrpg">
                            <el-col :span="24">
                                <el-form-item label="贷款合同："  style="width: 90%">
                                    {{dataForm.fi__transactionNo}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="客户名称："  style="width: 90%">
                                    {{dataForm.fi__customerName}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="贷款状态："  style="width: 90%">
                                    {{'Financing_'+ dataForm.fi__transactionStatus|Status2CN}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="贷款金额："  style="width: 90%">
                                    {{dataForm.fi__totalAmount|formatMoney}} 元
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="还款日期：" prop="t__checkoutTime"  label-width="150px">
                                    {{dataForm.settle__settleDate? $moment(dataForm.settle__settleDate).format('YYYY-MM-DD'):''}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="出库原因：" prop="t__reason" :rules="{required: true, message: '不能为空'}">
                                    <el-select placeholder="请选择出库原因" v-model.trim="dataForm.t__reason" >
                                        <el-option label="结清释放" value="结清释放" ></el-option>
                                        <el-option label="债权转移" value="债权转移" ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="代理人：" prop="t__proxyPersonName" :rules="{required: false, message: '不能为空'}">
                                    <el-select placeholder="请选择" v-model.trim="dataForm.t__proxyPersonName" clearable >
                                        <el-option :label="item.label" :value="item.value" v-for="(item,idx) in proxyPersonOptions" :key="idx"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>

                            <el-col :span="24">
                                <el-form-item label="备注：" prop="t__remarks" style="width: 50%">
                                    <el-input v-model="dataForm.t__remarks" type="textarea"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </panel>
                <panel label="增贷信息" v-if="relatedList.length > 0">
                    <el-form :model="dataForm" :rules="dataFormRules" label-width="150px">
                        <el-row :gutter="10" class="bg-purple xamhtrpg" v-for="(relatedItem, relatedIdx) in relatedList" :key="relatedIdx" style="border:1px solid #C0C4CC">
                            <el-col :span="12">
                                <el-form-item label="贷款编号："  style="width: 90%">
                                    {{relatedItem.rfi__contractNo}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="贷款金额："  style="width: 90%">
                                    {{relatedItem.rfi__totalAmount|formatMoney}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="贷款状态："  style="width: 90%">
                                    {{'Financing_' + relatedItem.rfi__transactionStatus|Status2CN}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="还款日期："  style="width: 90%">
                                    {{relatedItem.rsettle__settleDate? $moment(dataForm.settle__settleDate).format('YYYY-MM-DD'):''}}
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </panel>
                <panel label="他项权证">
                    <el-form :model="dataForm" :rules="dataFormRules" ref="dataForm" label-width="150px">
                        <el-row :gutter="10" class="bg-purple xamhtrpg">
                            <el-col :span="12" v-for="(item, idx) in dataForm.properties" :key="idx" >
                                <el-form-item  :label="'他项权证号'+(idx+1)+'：'"  style="width: 90%">
                                    {{item.doc__hisWarrantNo}}
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </panel>
                <panel label="相关材料" class="zhengjianxinxi">
                    <div class="zhenjianyyzz zhenjianyyzz2" v-for="(item, idx) in dataForm.properties" :key="idx">
                        <photo-browser v-model="item.doc__hisWarrant" type='image' :label="'他项权证'+(idx+1)"/>
                    </div>
                </panel>
                <panel title="盖章文件">
                    <files-upload :file-list.sync="dataForm.attachments" :max="100" :allow-file-ext="['PDF', 'Word', 'Excel', 'JPG', 'PNG', 'BMP', 'GIF', 'RAR', 'ZIP']" ></files-upload>
                </panel>
            </el-col>
        </el-row>
        <div class="tr xzmt">
            <el-button type="primary" @click="onSubmit('dataForm')">确认提交</el-button>
            <el-button @click="$router.back()">取消</el-button>
        </div>
        </div>
    </template>

    <script>
        import xhr from '../../utils/xhr'
        import moment from 'moment'
        import {xmlBuildQuery} from "../../filters/CommonActions";
        import Status2CN from "../../filters/Status2CN";
        import Panel from "../../components/Panel";
        import {formatMoney} from "../../filters/CommonFilters";
        export default {
            name: "HisWarrantCheckout",
            data() {
                return {
                    proxyPersonOptions:[],
                    transactionId:this.$route.query['transactionId']||'',
                    dataForm:{
                        related: []
                    },
                    dataFormRules:{},
                }
            },
            computed: {
                relatedList() {
                    return this.dataForm.related.filter(item=>item.rfi__contractNo)
                }
            },
            filters: {

                Status2CN
            },
            watch:{
                'dataForm.t__proxyPersonName':function (newVal) {
                    if(this.proxyPersonOptions.length>0) {
                        let contactNo = (this.proxyPersonOptions.filter(item => item.value == newVal)[0] || {}).p__contactNo
                        let IC = (this.proxyPersonOptions.filter(item => item.value == newVal)[0] || {}).p__IC

                        this.dataForm.t__proxyPersonContactNo = contactNo
                        this.dataForm.t__proxyPersonIC = IC
                    }
                },
            },
            mounted() {
                if (this.transactionId) {
                    this.getData()
                }
                this.getProxyPersonList()
            },
            methods:{
                getData: function () {
                    xhr.getViewFinancingForHisWarrantCheckout({
                        'fi.transactionId': this.$route.query['transactionId']
                    }, res=>{
                        try{
                            if(res.data.status == 'success') {
                                const dataForm = res.data.data
                                dataForm.attachments = []

                                this.dataForm = dataForm
                            }
                        }catch(e){}
                    })
                },
                getProxyPersonList: function () {
                    xhr.getProxyPersonList(
                        Object.assign({pageSize:0}, {},{}),
                        res=> {
                            try {
                                this.proxyPersonOptions = []
                                this.proxyPersonOptions = res.data.data.map(item=>{
                                    return {
                                        label: item.p__name+(item.p__contactNo?("-"+item.p__contactNo):''),
                                        value:item.p__name,
                                        'p__contactNo':item.p__contactNo,
                                        'p__IC':item.p__IC,
                                    }

                                })
                                this.customerColumns[27].options = this.proxyPersonOptions||[]
                            }catch(e){

                            }
                        })

                },
                onSubmit: function (formName) {
                    this.$refs[formName].validate(valid=> {
                        if (valid) {
                            let saveForm = {
                                'fi__transactionId':this.dataForm.fi__transactionId,
                                't__reason':this.dataForm.t__reason,
                                't__remarks':this.dataForm.t__remarks,
                                't__proxyPersonName':this.dataForm.t__proxyPersonName,
                                't__proxyPersonContactNo':this.dataForm.t__proxyPersonContactNo,
                                't__proxyPersonIC':this.dataForm.t__proxyPersonIC,
                                detail:[],
                                attachments:this.dataForm.attachments,
                            }
                            this.dataForm.properties.forEach(item=>{
                                saveForm.detail.push(
                                    {
                                        de__checked:true,
                                        de__hisWarrant :  item.doc__hisWarrant,
                                        de__hisWarrantNo :  item.doc__hisWarrantNo
                                    }
                                )
                            })
                            this.dataForm.attachments.forEach(item=>{
                                        item.docs__checked = true
                                        item.docs__fileId = item.fileId
                            })
                            xhr.updateHisWarrantCheckout(saveForm, res=> {
                                try {
                                    if (res.data.status == 'success') {
                                        this.$router.push({
                                            name: 'HisWarrantCheckoutListView'
                                        })
                                    }
                                } catch (e) {
                                }
                            })
                        }
                    })
                }
            }
        }
    </script>

    <style scoped>

    </style>



// WEBPACK FOOTER //
// src/views/fang/HisWarrantCheckout.vue